import { render } from "./optimize.vue?vue&type=template&id=5e9e2294"
import script from "./optimize.vue?vue&type=script&lang=js"
export * from "./optimize.vue?vue&type=script&lang=js"

import "./optimize.vue?vue&type=style&index=0&id=5e9e2294&lang=scss"
import "./optimize.vue?vue&type=style&index=1&id=5e9e2294&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__